import { FacilityFormValues } from '~/features/types';
import { Facility } from '~/types';
import { getData, postData } from '../../../utils/service';
import { SubmitFacilityEvent } from './events';
import { Context } from './types';
import { facilitiesApiToForm, facilityApiToForm, facilityFormToApi } from './utils';

const ROUTE_NAME = 'facilities';
interface ApiProps<T> {
  input: {
    context: Context;
    event: T;
  };
}

const searchFacilities = async (routeName: 'facilities' | 'publicFacilities', input: string) => {
  const results = await getData<FacilityFormValues[]>(routeName, {
    params: { name: input, limit: 20 },
    transformResponse: facilitiesApiToForm,
  });
  // Deduplicate by normalized facility name to prevent showing duplicate entries.
  // [MCV-1876] The label is built from the name with its own location stripped, so
  // this also collapses copies whose stored names carried their own location.
  const seen = new Set<string>();
  return results.filter((f) => {
    const key = f.label?.toLowerCase().trim();
    if (!key) {
      console.debug('Facility with empty label skipped during dedup:', f);
      return false;
    }
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const API_CALLS = {
  create: async ({ input }: ApiProps<SubmitFacilityEvent>): Promise<Facility> => {
    return await postData(ROUTE_NAME, {
      data: input.event.values,
      transformRequest: facilityFormToApi,
      transformResponse: facilityApiToForm,
    });
  },
  get: async (input: string) => {
    return searchFacilities(ROUTE_NAME, input);
  },
  getPublic: async (input: string) => {
    return searchFacilities('publicFacilities', input);
  },
};
